import { render, staticRenderFns } from "./popup-yandex.vue?vue&type=template&id=3a06772b&scoped=true&"
import script from "./popup-yandex.vue?vue&type=script&lang=js&"
export * from "./popup-yandex.vue?vue&type=script&lang=js&"
import style0 from "./popup-yandex.vue?vue&type=style&index=0&id=3a06772b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a06772b",
  null
  
)

export default component.exports